import {
  name,
  manufacturer,
  manufacturerNumber,
  computerEaseNumber,
  color
} from '@/modules/standardItems/schemas/baseHeaders'

export default [
  name(),
  manufacturer(),
  manufacturerNumber(),
  computerEaseNumber(),
  color()
]
